export const PAYMENT = {
    CREDIT_CARD: 'credit-card',
    PAYPAL: 'paypal',
    WEB_GATEWAY: 'adyen',
    // All possible paypal responses
    PAYPAL_AUTH_RESULT: {
        REFUSED: 'REFUSED',
        AUTHORISED: 'AUTHORISED',
        PENDING: 'PENDING',
        CANCELLED: 'CANCELLED',
    },
    coupons: {
        winback_25: 'winback_25',
        black_friday: 'black_friday_2021',
        yousician_25: 'yousician_25',
        premium_offer: 'premium_offer_2020',
        premium_plus_offer: 'premium_plus_offer_2020',
        world_music_day: 'world_music_day_2020',
        new_year: 'new_year_2020',
        back_to_school: 'back_to_school_19',
        april_discount: 'april_discount_2021',
        partnershipJason: 'partnership_jason_2021',
    },

    INSTALLMENT_PLAN_IDS: [
        'yearly_m',
        'yearly_m_licensed',
        'yearly_m_alt_a',
        'yearly_m_licensed_alt_a',
        'yearly_m_alt_b',
        'yearly_m_licensed_alt_b',
        'yearly_m_all',
    ],
};
